import CommonApiError from '../../../errors/CommonApiError'
import parseHttpApiError from '../../../utils/parseHttpApiError'
import { MyUpdateExtraDocument } from '../../__generated__/graphql'
import { executeGraphQL } from '../../client'
import { IGQLApiError } from '../../types'
import { UpdateExtraInput } from '../../user-extra'

const myUpdateExtra = async <T>(data: UpdateExtraInput<T>, authToken: string): Promise<string> => {
    try {
        const result = await executeGraphQL(
            MyUpdateExtraDocument,
            { input: data },
            { accessToken: authToken },
        )
        return result.myUpdateExtra
    } catch (err: unknown) {
        if (err instanceof CommonApiError) {
            throw parseHttpApiError(err.body as IGQLApiError[])
        }
        throw err
    }
}

export default myUpdateExtra
